// assets/js/solutions-hero.js

export function initSolutionsHero() {
  const LIST_SELECTOR = '.c-solutions-hero_list';
  const ITEM_SELECTOR = '.c-solutions-hero_item';
  const MOBILE_MQ = window.matchMedia('(max-width: 991px)');

  function initList(list) {
    const items = Array.from(list.querySelectorAll(ITEM_SELECTOR));
    if (!items.length) return;

    items.forEach((item) => {
      item.addEventListener('click', (event) => {
        // Laisse les clics sur les liens tranquilles
        if (event.target.closest('a')) {
          return;
        }

        // On ne joue avec .is-active que sur mobile / tablette
        if (!MOBILE_MQ.matches) {
          return;
        }

        const isActive = item.classList.contains('is-active');
        items.forEach((it) => it.classList.remove('is-active'));
        if (!isActive) {
          item.classList.add('is-active');
        }
      });
    });
  }

  const initAll = () => {
    document.querySelectorAll(LIST_SELECTOR).forEach(initList);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
}
